import { useEffect, useState } from "react";

const getEmployeeId = employee =>
  employee?.id ?? employee?.empId ?? employee?.employeeId ?? employee?.employee_id ?? "";

const getEmployeeLabel = employee => {
  const name = employee?.name || employee?.fullName || employee?.employeeName || employee?.empName || "";
  const code = employee?.empCode || employee?.empcode || employee?.employeeCode || "";
  return code && name ? `${code} - ${name}` : name || code || `Employee ${getEmployeeId(employee)}`;
};

function SalaryForm({ employees = [], selectedSite, initialData = null, onSave, onClose }) {
  const [form, setForm] = useState({});

  useEffect(() => {
    setForm({
      salaryDate: String(initialData?.salaryDate || "").slice(0, 10),
      employee: initialData?.employee || null,
      paidByEmployee: initialData?.paidByEmployee || null,
      salaryAmount: initialData?.salaryAmount ?? "",
      previousPendingAmount: initialData?.previousPendingAmount ?? "",
      remarks: initialData?.remarks || "",
      file: null,
    });
  }, [initialData]);

  const updateEmployee = (field, value) => {
    const employee = employees.find(item => String(getEmployeeId(item)) === value) || null;
    setForm(current => ({ ...current, [field]: employee }));
  };

  const save = () => {
    if (!form.salaryDate || !form.employee || form.salaryAmount === "" || !selectedSite?.id) {
      return;
    }
    if (Number(form.salaryAmount) < 0 || (form.previousPendingAmount !== "" && Number(form.previousPendingAmount) < 0)) {
      return;
    }
    onSave({ ...form, salaryAmount: Number(form.salaryAmount), previousPendingAmount: form.previousPendingAmount === "" ? null : Number(form.previousPendingAmount) });
  };

  return (
    <div>
      <div className="form-grid">
        <div className="field">
          <label htmlFor="salary-date">Salary Date *</label>
          <input id="salary-date" type="date" value={form.salaryDate || ""} onChange={e => setForm(current => ({ ...current, salaryDate: e.target.value }))} />
        </div>
        <div className="field">
          <label htmlFor="salary-employee">Employee *</label>
          <select id="salary-employee" value={getEmployeeId(form.employee)} onChange={e => updateEmployee("employee", e.target.value)}>
            <option value="">Select employee</option>
            {employees.map(employee => <option key={getEmployeeId(employee)} value={getEmployeeId(employee)}>{getEmployeeLabel(employee)}</option>)}
          </select>
        </div>
        <div className="field">
          <label htmlFor="salary-paid-by">Paid By</label>
          <select id="salary-paid-by" value={getEmployeeId(form.paidByEmployee)} onChange={e => updateEmployee("paidByEmployee", e.target.value)}>
            <option value="">Select employee</option>
            {employees.map(employee => <option key={getEmployeeId(employee)} value={getEmployeeId(employee)}>{getEmployeeLabel(employee)}</option>)}
          </select>
        </div>
        <div className="field">
          <label htmlFor="salary-amount">Salary Amount (₹) *</label>
          <input id="salary-amount" type="number" min="0" step="0.01" value={form.salaryAmount ?? ""} onChange={e => setForm(current => ({ ...current, salaryAmount: e.target.value }))} />
        </div>
        <div className="field">
          <label htmlFor="salary-pending">Previous Pending Amount (₹)</label>
          <input id="salary-pending" type="number" min="0" step="0.01" value={form.previousPendingAmount ?? ""} onChange={e => setForm(current => ({ ...current, previousPendingAmount: e.target.value }))} />
        </div>
        <div className="field">
          <label>Site</label>
          <input value={selectedSite?.siteName || selectedSite?.site_name || selectedSite?.name || ""} readOnly />
        </div>
        <div className="field" style={{ gridColumn: "1 / -1" }}>
          <label htmlFor="salary-remarks">Remarks</label>
          <textarea id="salary-remarks" rows="3" maxLength="500" value={form.remarks || ""} onChange={e => setForm(current => ({ ...current, remarks: e.target.value }))} />
        </div>
        <div className="field" style={{ gridColumn: "1 / -1" }}>
          <label htmlFor="salary-document">Document</label>
          <input id="salary-document" type="file" onChange={e => setForm(current => ({ ...current, file: e.target.files?.[0] || null }))} />
          {form.file && <small>Selected: {form.file.name}</small>}
          {!form.file && (initialData?.document?.fileName || initialData?.document?.filename) && <small>Existing document: {initialData.document.fileName || initialData.document.filename}</small>}
        </div>
      </div>
      {!selectedSite?.id && <p role="alert">Select a site before adding salary.</p>}
      <div className="form-actions">
        <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
        <button type="button" className="btn-primary" onClick={save}>{initialData ? "Update Salary" : "Save Salary"}</button>
      </div>
    </div>
  );
}

export default SalaryForm;
